import { useEffect } from 'react';

import { queryClient } from 'providers/queryClient';
import { ACTIVE_IMPORT_ID_KEY } from 'shared/widgets/RequestsBankOpsImport/hooks/useGetActiveImportId';
import { ImportFileStatuses, ImportFileStatusesValue } from 'types/embedded/bankOperation';

const REMOVE_CACHE_DELAY = 5000;

export const useRemoveImportCacheOnFail = (
  id: string | undefined,
  status: ImportFileStatusesValue | undefined,
) => {
  useEffect(() => {
    if (status === ImportFileStatuses.Fail) {
      const timer = setTimeout(() => {
        queryClient.removeQueries({ queryKey: [ACTIVE_IMPORT_ID_KEY, id] });
      }, REMOVE_CACHE_DELAY);

      return () => clearTimeout(timer);
    }
  }, [status, id]);
};
